// extracted by mini-css-extract-plugin
module.exports = {"sliderText":"SetupRecsAudience_sliderText__1Dt29","sliderWrapper":"SetupRecsAudience_sliderWrapper__2SST6"};